import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input} from '@angular/core';


@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    standalone: false
})
export class OtpComponent implements OnInit {
  @Output() onOtpProcess: EventEmitter<any> = new EventEmitter();
  @Output() onOtpPopClose: EventEmitter<any> = new EventEmitter();
  @Output() onOtpPopSave: EventEmitter<any> = new EventEmitter();
  @Input() inputRequired = true;
  @Input() inputLabel;
  otpForm = new UntypedFormGroup({
    otpInput: new UntypedFormControl()
  });
  constructor(private formBuilder: UntypedFormBuilder, ) { }

  ngOnInit() {
    this.otpForm = this.formBuilder.group({
      otpInput: ['', [Validators.required]],
    });

    if (!this.inputRequired) {
      this.otpForm.controls.otpInput.setValue('notRequired');
    }
  }

  closeEditForgot(event) {
    if (!this.inputRequired) {
      this.otpForm.controls.otpInput.setValue('notRequired');
    } else {
      this.otpForm.reset();
    }
    this.onOtpPopClose.emit();
  }


  OTPProcess(event) {
    const otpInput = this.otpForm.controls.otpInput.value;
    this.otpForm.reset();
    this.onOtpProcess.emit(otpInput);
  }


}
